export default "__VITE_ASSET__FHdlFgyQ__"